






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Program from '@/models/Program';
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Address from '../models/Address';
import compact from 'lodash/compact';
import { MAP_PROVIDER, MAP_ATTRIBUTION } from '@/helpers/constants';

// this part resolve an issue where the markers would not appear
// @ts-ignore
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface Position {
    lat: number;
    lng: number;
}

interface Bounds {
    _northEast: {
        lat: number;
        lng: number;
    };
    _southWest: {
        lat: number;
        lng: number;
    };
}

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
    },
    filters: {
        formatAddress(address: Address) {
            const _street = [address.street, address.street2];
            const street = compact(_street);
            const streetStr = street.join(', ');

            return `${streetStr}, ${address.city} (${address.postal_code})`;
        },
    },
})
export default class Map extends Vue {
    @Prop() program!: Program;
    @Prop({ type: Boolean, default: false }) showAddress!: boolean;

    @Watch('program', { deep: true })
    async onProgram() {
        if (!this.program || !this.program.address) {
            return;
        }

        const { address } = this.program;
        const { latitude, longitude } = address;

        if (latitude && longitude) {
            this.zoom = 12;

            setTimeout(() => {
                const center: Position = {
                    lat: latitude,
                    lng: longitude,
                };

                this.center = center;
                this.markerLatLng = center;
            }, 1);
        }
    }

    created() {
        this.onProgram();
    }

    beforeDestroy() {
        const lmap = this.$refs.lmap as any;
        if (lmap && lmap.mapObject) {
            lmap.mapObject.remove();
        }
    }

    url = MAP_PROVIDER;
    attribution = MAP_ATTRIBUTION;
    zoom = 5;
    center: Position = {
        lng: 1.8457033745605995,
        lat: 46.77123209189192,
    };
    markerLatLng: Position | null = null;
    bounds: Bounds | null = null;

    zoomUpdated(zoom: number) {
        this.zoom = zoom;
    }
    centerUpdated(center: Position) {
        this.center = center;
    }
    boundsUpdated(bounds: Bounds) {
        this.bounds = bounds;
    }
}
